import { Routes } from '@angular/router';
import { ExpiredComponent } from './expired/expired.component';
import { expiredGuard } from './expired/expired.guard';
import { fallaufgabeResolver } from './fallaufgabe-resolver';
import { IntroductionComponent } from './introduction/introduction.component';
import { introductionGuard } from './introduction/introduction.guard';
import { jwtFromUrlGuard } from './jwtFromUrlGuard.guard';
import { Layout } from './layout/layout';
import { LernbegleiterComponent } from './lernbegleiter/lernbegleiter.component';
import { lernbegleiterGuard } from './lernbegleiter/lernbegleiter.guard';
import { socketResolver } from './lernbegleiter/socket-resolver';
import { NotfoundComponent } from './notfound/notfound.component';
import { OutroComponent } from './outro/outro.component';
import { solutionsResolver } from './solution-resolver';

export const routes: Routes = [
    {
        path: 'lernbegleiter',
        component: LernbegleiterComponent,
        canActivate: [lernbegleiterGuard],
        resolve: {
            fallaufgabe: fallaufgabeResolver,
            solutions: solutionsResolver,
            socket: socketResolver
        }
    },
    {
        path: '',
        component: Layout,
        children: [
            {
                path: '',
                canActivate: [jwtFromUrlGuard],
                component: NotfoundComponent,
                pathMatch: "full"
            },
            {
                path: 'introduction',
                component: IntroductionComponent,
                canActivate: [introductionGuard],
                resolve: { fallaufgabe: fallaufgabeResolver }
            },
            {
                path: 'outro',
                component: OutroComponent,
                resolve: {}
            },
            {
                path: 'expired',
                component: ExpiredComponent,
                canActivate: [expiredGuard]
            },
            {
                path: '**',
                component: NotfoundComponent,
            }
        ]
    }
];